/* Main super component */

/* CSS Styles */
import '../assets/css/main.css'

/* SASS Styles */
import '../assets/css/main.scss'

/* Import libs */
import '../assets/lib/skip-link-focus-fix'

/* lucci ovipro */
import '../assets/js/lucci-ovipro'
import '../assets/js/search-realties-form'

import realtySlider from '../assets/js/realty-slider'
import realtiesSwiper from '../assets/js/realties-swiper'

const appStart = () => {
    realtySlider.init()
    realtiesSwiper.init()
}
  
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', appStart)
} else {
    appStart()
}
  